import { useSupabaseLoader } from "../../../server/supabase/hooks";
import { SupabaseWhatsAppTemplateService } from "../server/whatsapp-moment-service";

import type { UUID } from "../../../utils/uuid";
import type { WhatsAppTemplate } from "../types";

export const useWhatsAppTemplates = (
  selectedTemplateId?: UUID,
): ReturnType<typeof useSupabaseLoader<WhatsAppTemplate[]>> =>
  useSupabaseLoader(
    async ({ supabase, account_id }) => {
      const service = new SupabaseWhatsAppTemplateService(supabase);
      const [{ data, error }, selected] = await Promise.all([
        service.getActive(account_id),
        selectedTemplateId ? service.get(selectedTemplateId) : Promise.resolve({ data: null }),
      ]);
      if (error) throw new Error(error.message);
      const templates = data ?? [];
      return selected.data && !templates.some(({ id }) => id === selected.data?.id)
        ? [...templates, selected.data]
        : templates;
    },
    [selectedTemplateId],
  );
